import {Component, ContentChildren, OnInit, QueryList} from '@angular/core';
import {SelectInputOptionComponent} from './select-input-option/select-input-option.component';

@Component({
    selector: 'vui-select-input-options',
    templateUrl: './select-input-options.component.html',
    styleUrls: ['./select-input-options.component.scss']
})
export class SelectInputOptionsComponent implements OnInit {
    @ContentChildren(SelectInputOptionComponent) public selectInputOptions: QueryList<SelectInputOptionComponent>;

    constructor() {
        this.selectInputOptions = new QueryList<SelectInputOptionComponent>();
    }

    ngOnInit() {
    }
}
